import { gql } from '@apollo/client';

export default gql`
  fragment PaymentExchangePayment on Payment {
    refId
    currency
    method
    amount: amountWithCurrency(currency: $currency)
    isSuccessful
    paymentStatus
    reference
    createdRevision
  }
`;
